<template>
  <div style="marginx-">
    <!-- 上课邀请 -->
    <span class="systemFont1" style="margin-top: 35px">{{
      $t("p0322.classInvitation")
    }}</span>
    <el-row class="systemFont1" style="margin-top: 35px">
      <el-col :span="18" :offset="3">
        <!-- 编号 -->
        <el-col :span="4"
          >{{ $t("p0322.numbering") }}：{{
            field + category + courseNumber
          }}</el-col
        >
        <!-- 课程名称 -->
        <el-col :span="9"
          >{{ $t("p0322.courseTitle") }}：{{ courseName }}</el-col
        >
        <!-- 上课日期 -->
        <el-col v-if="formFlag" :span="7"
          >{{ $t("p0322.classDates") }}：{{ formatClassDates() }}</el-col
        >
        <!-- 报名人数 -->
        <el-col v-if="formFlag" :span="4"
          >{{ $t("p0322.applicantNumber") }}：{{ personNO }}</el-col
        >
        <!-- 学习中人数 -->
        <el-col v-if="!formFlag" :span="6"
          >{{ $t("p0322.numberPeopleLearning") }}：{{ personNO }}</el-col
        >
        <!-- 累计报名人数 -->
        <el-col v-if="!formFlag" :span="5"
          >{{ $t("p0322.cumulativeNumberApplicants") }}：{{
            summationRecording
          }}</el-col
        >
      </el-col>
    </el-row>
    <el-row v-if="scheduleStatus" style="margin-top: 7px">
      <el-col :span="24">
        <el-col :span="4" :offset="20">
          <!-- 添加学生 -->
          <el-button type="p0322Button" plain @click="openDialog()">{{
            $t("p0322.addStudents")
          }}</el-button>
          <el-dialog
            class="roll-dialog"
            :visible.sync="dialogVisible"
            width="70%"
            center
          >
            <emp-add
              :p0322Input="p0322Input"
              :closeDialog="closeDialog"
              :selectInviteStudents="selectInviteStudents"
              ref="empAdd"
            ></emp-add></el-dialog
        ></el-col>
      </el-col>
    </el-row>
    <el-row style="margin-top: 7px">
      <el-col :span="22" :offset="1">
        <el-table
          ref="inviteStudentsTable"
          :data="inviteStudentsData"
          :row-class-name="getFontColor"
          v-loading="tableLoading"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column v-if="scheduleStatus" type="selection" :selected="true" min-width="10">
          </el-table-column>
          <!-- 姓名 -->
          <el-table-column :label="$t('p0322.name')" min-width="3">
            <template slot-scope="scope">{{
              scope.row.lastName + " " + scope.row.firstName
            }}</template>
          </el-table-column>
          <!-- 试听 -->
          <el-table-column min-width="4">
            <template slot="header">
              <span style="margin-left:24px;">
                {{ $t("p0322.audition") }}
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('p0322.auditionTip')"
                  placement="top"
                >
                  <i
                    class="el-icon-warning"
                    style="opacity: 0.4;width: 18px;height: 18px;display: inline-block; position: absolute;top: 50%;transform: translate(0, -45%); margin-left:4px;"
                  ></i>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-checkbox
                @change="saveAudition"
                :disabled="!scheduleStatus"
                v-model="scope.row.audition"
                >{{ $t("p0322.audition") }}</el-checkbox
              >
            </template>
          </el-table-column>
          <!-- 邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0322.mail')"
            min-width="10"
          >
          </el-table-column>
          <!-- 手机 -->
          <el-table-column
            prop="phoneArea"
            :label="$t('p0322.cellPhone')"
            min-width="6"
          >
            <template slot-scope="scope">{{
              scope.row.phoneArea + scope.row.phoneNo !== 0
                ? scope.row.phoneArea + scope.row.phoneNo
                : ""
            }}</template>
          </el-table-column>
          <!-- 公司 -->
          <el-table-column
            prop="existingCompany"
            :label="$t('p0322.company')"
            min-width="10"
          >
          </el-table-column>
          <!-- 职位 -->
          <el-table-column
            prop="position"
            :label="$t('p0322.position')"
            min-width="5"
          >
          </el-table-column>
          <!-- 状态 -->
          <el-table-column
            prop="invitationStatus"
            :label="$t('p0322.state')"
            min-width="4"
          >
            <template slot-scope="scope">{{
              scope.row.invitationStatus === "1"
                ? $t("p0322.invited")
                : scope.row.invitationStatus === "2"
                ? $t("p0322.invitedFaild")
                : $t("p0322.notInvited")
            }}</template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin: 50px">
      <el-col :span="4" :offset="10" style="margin-bottom: 50px">
        <el-col v-if="scheduleStatus" :span="12">
          <!-- 发邀请 -->
          <el-button type="submit" @click="inviteStudentsAndSendEmail()">{{
            $t("p0322.sendAnInvitation")
          }}</el-button></el-col
        >
        <!-- 返回 -->
        <el-col :span="scheduleStatus?12:24"
          ><el-button type="return" @click="p0322Return()">{{
            $t("p0322.return")
          }}</el-button>
        </el-col>
      </el-col>
    </el-row>
    <!-- 邀请失败 错误信息 -->
    <el-dialog
      :visible.sync="listVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="dialog"
    >
      <el-table :data="errMsgList" style="margin-bottom: 75px">
        <el-table-column
          label="部分学员邮件/短信发送失败，请检查邮箱/手机号是否正确！"
          align="center"
          class="errdialog"
        >
          <template slot-scope="scope">
            <span class="errdialog">{{ scope.row }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import empAdd from "../../views/GreenJacketForum/P0323";
import { mapToWin8 } from "node-notifier/lib/utils";
export default {
  name: "demo",
  components: {
    empAdd
  },
  data() {
    let p0321 = JSON.parse(sessionStorage.getItem("p0321"));
    return {
      formFlag: p0321.formCode !== "02",
      summationRecording: 0,
      tableLoading: false,
      // 表格数据
      inviteStudentsData: [],
      classInvitationVos: [],
      dialogVisible: false,
      field: p0321.field,
      category: p0321.category,
      courseNumber: p0321.courseNumber,
      courseName: p0321.courseName,
      formCode: p0321.formCode,
      dateAndTime: moment(p0321.dateAndTime).format("YYYY-MM-DD HH:mm:ss"),
      scheduleStatus:p0321.scheduleStatus===1,
      // 人数
      personNO: "",
      summationRecording: "",
      // 组件数据
      p0322Input: {
        field: p0321.field,
        category: p0321.category,
        courseNumber: p0321.courseNumber,
        dateAndTime: p0321.dateAndTime
      },
      // 异常成员一览
      errMemberList: [],
      // 异常信息一览
      errMsgList: [],
      // 错误信息对话框是否显示
      listVisible: false
    };
  },
  methods: {
    //格式化上课日期
    formatClassDates() {
      return moment(this.dateAndTime).format("YYYY-MM-DD HH:mm");
    },
    // 返回
    p0322Return() {
      this.$router.push({
        path: "/views/GreenJacketForum/P0321",
        query: {
          dateAndTime: this.$route.query.dateAndTime,
          courseName: this.$route.query.courseName,
          currentPageCo: this.$route.query.currentPageCo,
          scheduleStatus: this.$route.query.scheduleStatus,
          totalCo: this.$route.query.totalCo,
          pageSizeCo: this.$route.query.pageSizeCo
        }
      });
    },
    // 打开dialog
    openDialog() {
      this.dialogVisible = true;
      // 清除dialog数据
      this.$nextTick(function() {
        this.$refs.empAdd.openP0323();
      });
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 初始化
    selectInviteStudents() {
      this.tableLoading = true;
      let url = "/api/classInvitation/selectInviteStudents";
      this.$http
        .post(url, {
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: this.dateAndTime,
          formCode: this.formCode
        })
        .then(response => {
          this.tableLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.inviteStudentsData = response.data.data.classInvitationVos.map(
              item => {
                return { ...item, audition: item.auditionStatus == 0 };
              }
            );
            this.checkinviteStudentsData(this.inviteStudentsData);
            this.checkEmailSendErrData(this.inviteStudentsData);
            // 报名人数
            this.personNO =
              this.inviteStudentsData.length + this.$t("p0322.person");
            this.summationRecording =
              response.data.data.summationRecording + this.$t("p0322.person");
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          this.tableLoading = false;
          this.$message.error(err);
        });
    },
    // 邮件发送失败学员处理
    checkEmailSendErrData(val) {
      let i = 0;
      // 异常信息清空
      this.errMsgList = [];
      // 异常学员情报遍历，做成异常信息一览
      this.errMemberList.forEach(errMb => {
        val.forEach(elt => {
          if (elt.email === errMb) {
            this.errMsgList[i] = elt.lastName + elt.firstName + " :  " + errMb;
            i++;
          }
          if (elt.phoneArea + elt.phoneNo === errMb) {
            this.errMsgList[i] = elt.lastName + elt.firstName + " :  " + errMb;
            i++;
          }
        });
      });
      // 若异常信息存在，异常信息弹框表示
      if (this.errMsgList.length > 0) {
        this.listVisible = true;
      } else {
        this.listVisible = false;
      }
      // 处理完后，异常成员一览清空
      this.errMemberList = [];
    },
    // 默认勾选
    checkinviteStudentsData(val) {
      this.$nextTick(function() {
        val.forEach(rows => {
          if (rows.invitationStatus === "0") {
            this.$refs.inviteStudentsTable.toggleRowSelection(rows);
          }
        });
      });
    },
    //验证邮箱
    checkEmail() {
      let checkEmail = 0;
      this.$refs.inviteStudentsTable.selection.forEach(element => {
        if (element.email === null || element.email === "") {
          checkEmail = 1;
          return checkEmail;
        }
      });
      return checkEmail;
    },
    //邀请学员并发送邮件
    inviteStudentsAndSendEmail() {
      // if(this.inviteStudentsData)
      this.classInvitationVos = this.$refs.inviteStudentsTable.selection;
      //验证是否存在空邮箱
      // if (this.checkEmail() === 1) {
      //   //邮箱不能为空
      //   this.$message.error(this.$t("p0322.emailCanNotBeEmpty"));
      //   return;
      // }
      //console.log(this.inviteStudentsData);
      if (this.classInvitationVos.length === 0) {
        //未选择学员
        this.$message.error(this.$t("p0322.noStudentSelected"));
        return;
      }
      // 该排课未填入上课链接！请先填入上课链接后再次尝试邀请！
      if (this.formCode !== "03" && this.inviteStudentsData[0].classLink == "") {
        if (this.formCode == "01") {
          this.$message.error(this.$t("p0322.text1"));
        } else if (this.formCode == "02") {
          this.$message.error(this.$t("p0322.text3"));
        }
        return;
      }
      // 该排课未填入会议号！请先填入会议号后再次尝试邀请！
      if (this.formCode == "01" && this.inviteStudentsData[0].meetingId == "") {
        this.$message.error(this.$t("p0322.text2"));
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      //课程名称
      let url = "/api/classInvitation/inviteStudentsAndSendEmail";
      this.$http
        .post(url, {
          classInvitationVos: this.classInvitationVos,
          userId: localStorage.getItem("userId"),
          courseName: this.courseName,
          field: this.field,
          category: this.category,
          courseNumber: this.courseNumber,
          dateAndTime: this.dateAndTime,
          form: this.formCode
        })
        .then(response => {
          this.response = JSON.stringify(response.data);
          this.errMemberList = response.data.data;
          if (response.data.code === 200) {
            this.selectInviteStudents();
            loading.close();
            // 邀请成功
            this.$message.success(this.$t("p0322.invitationSucceeded"));
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error(err);
        });
    },
    getFontColor({ row, rowIndex }) {
      if (row.invitationStatus === "2") {
        // alert(row.email)
        return "emailsendErr";
      } else {
        return "invitSuccess";
      }
    },
    // 保存试听状态
    saveAudition() {
      // 过滤与映射
      let data = this.inviteStudentsData
        .filter(item => {
          // 勾选
          if (item.audition == true && item.auditionStatus == "1") {
            return true;
          }
          // 取消勾选
          else if (item.audition == false && item.auditionStatus == "0") {
            return true;
          }
          return false;
        })
        .map(item => {
          return {
            auditionStatus: item.audition ? "0" : "1",
            field: item.field,
            category: item.category,
            courseNumber: item.courseNumber,
            userId: item.userId,
            dateAndTime: item.dateAndTime
          };
        });
      if (data.length == 0) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/classInvitation/saveAudition";
      this.$http
        .post(url, data)
        .then(response => {
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            // 初始化
            this.selectInviteStudents();
            loading.close();
            // 保存成功
            this.$message.success(this.$t("p0322.saveAudition"));
          } else {
            loading.close();
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          loading.close();
          this.$message.error(err);
        });
    }
  },
  mounted() {
    //初始化
    this.selectInviteStudents();
  },
  created() {}
};
</script>

<style lang="scss" scoped>
//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(90vh - 140px);
}
// 表格样式
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

// 模板dialog
.templateDialogCss {
  text-align: center;
  margin-top: 3%;
  margin-left: 10%;
}
>>> .el-dialog__body {
  height: auto;
  text-align: center;
}
.dialog {
  width: 1200px;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  >>> .el-dialog {
    margin: 0 auto !important;
    max-height: 80%;
    height: 80%;
    overflow: hidden;
    .el-dialog__body {
      position: absolute;
      left: 15px;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
    >>> .el-table .el-table__cell {
      padding: 7px 0;
    }
  }
}
.errdialog {
  height: 15px;
  border-color: rgb(204, 204, 204);
  font-size: 16px;
  font-family: Microsoft YaHei;
  padding: 7px 0;
}

>>> .el-table .emailsendErr {
  color: red;
}
>>> .el-table .emailsendErr .el-checkbox {
  color: red;
}
>>> .el-table
  .emailsendErr
  .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: red;
}
>>> .el-table .invitSuccess {
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/views/GreenJacketForum/P0322.vue